import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const HowWeWork = () => {
     const { t } = useTranslation();
    const [selectedItem, setSelectedItem] = useState<number | null>(null);
    const [isClosing, setIsClosing] = useState(false);
    const handleClose = () => {
      setIsClosing(true);
      setTimeout(() => {
        setSelectedItem(null);
        setIsClosing(false);
      }, 600);
    };

    const handleClick = (id: number) => {
        selectedItem === id ? setSelectedItem(null): setSelectedItem(id);
    };
    const items = [
      {
        id: 1,
        number: "01",
        title: t('meet'),
        description:
          t('explore1'),
          detailedSub: t('explore2')
      },
      {
        id: 2,
        number: "02",
        title: t('concept'),
        description:
          t('concept1'),
          detailedSub: t('concept2')
      },
      {
        id: 3,
        number: "03",
        title: t('createX'),
        description:
          t('createX1'),
          detailedSub: t('createX2')
      },
      {
        id: 4,
        number: "04",
        title: t('launch'),
        description:
          t('launch1'),
          detailedSub: t('launch2')
      },
    ];
    return (
      <>
        <style>{`
          .container {
            width: 100vw;
            background: white;
            position: relative;
            overflow-x: hidden;
          }
          .vertical-text {
            display: none;
            position: absolute;
            left: 40px;
            top: 10%;
            transform: translateY(-50%);
            writing-mode: vertical-lr;
            text-orientation: mixed;
            font-size: smaller;
            letter-spacing: 2px;
            color: #666;
            z-index: 1;
            transform: rotate(-180deg);
          }
          @media (min-width: 1024px) {
            .vertical-text {
              display: block;
            }
            .list {
              margin-left: 120px !important;
            }
          }
          .background {
            position: fixed;
            top: 100vh;
            left: 0;
            right: 0;
            bottom: 0;
            overflow: hidden;
            pointer-events: none;
          }
          .circle {
            position: absolute;
            border-radius: 50%;
            filter: blur(80px);
            opacity: 0.5;
            animation: float 20s infinite;
          }
          .circle:nth-child(1) {
            width: 400px;
            height: 400px;
            background: #e0e7ff;
            top: -100px;
            left: 20%;
            animation-delay: -2s;
          }
          .circle:nth-child(2) {
            width: 500px;
            height: 500px;
            background: #fce7f3;
            top: 40%;
            right: -100px;
            animation-delay: -4s;
          }
          .circle:nth-child(3) {
            width: 300px;
            height: 300px;
            background: #ddd6fe;
            bottom: -50px;
            left: 30%;
            animation-delay: -6s;
          }
          @keyframes float {
            0%, 100% { transform: translate(0, 0); }
            25% { transform: translate(100px, 100px); }
            50% { transform: translate(0, 200px); }
            75% { transform: translate(-100px, 100px); }
          }
          .list {
            max-width: 1400px;
            margin: 0 auto;
            padding: 40px 20px;
            position: relative;
            z-index: 1;
          }
          .list-item {
            padding: 40px;
            border-bottom: 1px solid rgba(0,0,0,0.1);
            cursor: pointer !important;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            display: flex;
            align-items: flex-start;
            position: relative;
            background: transparent;
          }
          .list-item:not(.selected):hover {
            transform: translateY(-2px);
          }
          .list-item.selected {
            z-index: 10;
            background: white;
            border: none;
            display: block;
            overflow-y: auto;
            transform: none;
            opacity: 1;
            cursor: auto;
            transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
            transition-delay: 0.2s;
          }
          .list-item:not(.selected) {
            opacity: 1;
            transform: ${selectedItem ? "translateY(20px)" : "translateY(0)"};
          
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
            transition-delay: 0s;
          }
          .item-content {
            transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
            opacity:  1;
            transition-delay: ${selectedItem ? "0s" : "0.3s"};
          }
          .selected .item-content {
            max-width: 1400px;
            margin: 60px auto;
            opacity: 1;
            transition-delay: 0.3s;
          }
          .item-number {
            font-size: 48px;
            font-weight: 300;
            margin-right: 40px;
            opacity: 0.3;
            transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
          }
          .selected .item-number {
            margin-bottom: 20px;
          }
          .item-title {
            font-size: 48px;
            font-weight: 500;
            margin: 0 0 20px 0;
            transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
          }
          .item-description {
            font-size: 16px;
            line-height: 1.5;
            color: #666;
            max-width: 600px;
            transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
          }
          .selected .item-description {
            margin-top: 40px;
            opacity: 1;
          }
          .close-button {
            position: absolute;
            top: 40px;
            right: 40px;
            background: none;
            border: none;
            font-size: 24px;
            cursor: pointer;
            padding: 8px;
            opacity: 0;
            transform: rotate(-90deg) scale(0.5);
            transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
          }
          .selected .close-button {
            opacity: 1;
            transform: rotate(0) scale(1);
          }
          .close-button:hover {
            transform: rotate(90deg) scale(1.1);
          }
          .navigation {
            margin-top: 40px;
            opacity: 0;
            transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
            transition-delay: 0.2s;
          }
          .selected .navigation {
            opacity: 1;

          }
          .nav-item {
            display: block;
            margin: 10px 0;
            color: #666;
            text-decoration: none;
            transition: color 0.3s ease;
          }
          .nav-item:hover {
            color: #000;
          }
          .detail-content {
            opacity: 0;
            font-size: 0.85rem;
            width: 70%;
            transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
            transition-delay: 0.3s;
          }
          .selected .detail-content {
            opacity: 1;
            // transform: translateY(0);
          }
        `}</style>
        <div className="container">
          <div className="vertical-text">{t('howWork')}</div>
          <div className="background">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
          </div>
          <div className="list">
            {items.map((item) => (
              <div
                key={item.id}
                className={`list-item ${selectedItem === item.id ? "selected" : ""}`}
                onClick={() => handleClick(item.id)}
              >
                <div className="item-content">
                  <div className="item-number">{item.number}</div>
                  <h2 className="item-title">{item.title}</h2>
                  <p className="item-description">
                   {selectedItem !== item.id && item.description}
                  </p>
                  {selectedItem === item.id && (
                    <>
                      <div className="detail-content">
                        {item.detailedSub}
                      </div>
                      <button
                        className="close-button"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleClose();
                        }}
                      >
                        ×
                      </button>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </>
    );
  }
  

export default HowWeWork;